import { normalizeStr } from 'helpers';

export const getCardColor = (type) => {
  switch (type) {
    case 'Voyage':
      return 'green';
    case 'Loisirs':
      return 'yellow';
    default:
      return 'blue';
  }
};

export const getBadgeColor = (type) => {
  switch (normalizeStr(type)) {
    case normalizeStr('Annulée'):
      return 'red';
    case normalizeStr('Validée'):
    case normalizeStr('Expédiée'):
    case normalizeStr('Disponible en point retrait'):
      return 'green';
    default:
      return 'yellow';
  }
};
